import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { colors } from 'src/styles/colors';
import { ZeeFontBold, ZeeFontRegular } from 'src/styles/font';
import { MediaBP as MQ } from 'src/styles/mediaQuery';
import { flex } from 'src/styles/utils';

export const Container = styled.div`
  position: relative;
  top: 100px;
  width: 100%;
  ${flex('column')};
  text-align: center;
`;

export const title = css`
  color: ${colors.PrimaryWhiteColorAlpha80};
  ${ZeeFontRegular(12)};
  margin-bottom: 32px;

  ${MQ.MediaLg} {
    ${ZeeFontRegular(18)};
  }
`;

export const content = css`
  color: ${colors.PrimaryWhiteColor};
  ${ZeeFontBold(16)};
  margin-bottom: 12px;
  ${MQ.MediaLg} {
    ${ZeeFontBold(24)};
    margin-bottom: 15px;
  }
`;

export const chooseMoreLanguages = css`
  color: ${colors.Lavender};
  ${ZeeFontBold(12, 14)};
  margin: 16px 0px;
  ${MQ.MediaLg} {
    ${ZeeFontBold(20)};
  }
`;

export const button = css`
  color: ${colors.white};
  ${ZeeFontBold(14, 38)};
  padding: 2px;
  min-width: 188px;
  width: fit-content;
`;
